import { DgtPdOrderPicklistExtraReturnItem } from "../models"
import { memo } from 'react'
import { EditorProps } from 'react-data-grid'
import Modal from './Modal'
import { AiOutlineFileAdd } from 'react-icons/ai'
import { MdDelete } from 'react-icons/md'

const DeleteReturnItemEditor = memo(({ props } : {
  props: EditorProps<DgtPdOrderPicklistExtraReturnItem | null>
}) => {
  const { onClose, onRowChange, row } = props

  return (row?.active === true || row?.active === null) ? <Modal show={true} onHide={onClose}
    okTheme='danger'
    okText='ยืนยัน'
    okAction={() => {
      let updatedRow = { 
        ...row,
        active: false
      } as DgtPdOrderPicklistExtraReturnItem
      onRowChange(updatedRow, true)
    }}
    cancelText='ปิด'
    title='คำเตือนเนื่องจากมีการลบรายการคืนจาก PD'
    maxWidth='max-w-xl'
    >
    <div className='flex items-center gap-3'>
      <MdDelete size={50} className='text-red-500 basis-1/6 ' />
      <div className="space-y-3 ">
        <h6>คุณกำลังจะลบรายการคืนจาก PD ดังนี้</h6>
        <h5 className="font-bold text-red-500">{row?.materialCode} - {row?.materialDescription}</h5>
        <h6>ยืนยันลบหรือไม่ ?</h6>
      </div>
    </div>
  </Modal> : <Modal show={true} onHide={onClose}
    okTheme='success'
    okText='ยืนยัน'
    okAction={() => {
      let updatedRow = { 
        ...row,
        active: true
      } as DgtPdOrderPicklistExtraReturnItem
      onRowChange(updatedRow, true)
    }}
    cancelText='ปิด'
    title='คำเตือนเนื่องจากมีการเปิดรายการคืนกลับมา'
    maxWidth='max-w-xl'
    >
    <div className='flex items-center gap-3'>
      <AiOutlineFileAdd size={50} className='text-green-500 basis-1/6 ' />
      <div className="space-y-3 ">
        <h6>คุณกำลังจะเปิดรายการคืนดังนี้</h6>
        <h5 className="font-bold text-green-500">{row?.materialCode} - {row?.materialDescription}</h5>
        <h6>ยืนยันเปิดหรือไม่ ?</h6>
      </div>
    </div>
  </Modal>
})

export default DeleteReturnItemEditor